import styled, { css } from 'styled-components';
import Icons from '../Icons';
import { TagVariants, TagStatus } from './tag-consts';

const STATUS_COLOR = {
  [TagStatus.SUCCESS]: 'var(--tag-status-success-color)',
  [TagStatus.WARNING]: 'var(--tag-status-warning-color)',
  [TagStatus.ERROR]: 'var(--tag-status-error-color)'
};

export const TagWrapper = styled.div.attrs(() => ({
  className: 'dsc-tagRoot'
}))`
  display: flex;
  padding: 0 8px;
  border-radius: 20px;
  height: 24px;
  width: fit-content;
  align-items: center;
  max-width: ${({ $maxWidth }) => $maxWidth || 'none'};

  ${({ $variant }) =>
    (($variant === TagVariants.CHIP || $variant === TagVariants.NAKED) &&
      css`
        border: ${() =>
          $variant === TagVariants.CHIP ? '1.5px solid var(--tag-chip-border-color)' : '1.5px solid transparent'};
        background-color: var(--tag-chip-bg-color, #0c5661);
        ${({ $selected }) => $selected && 'border: var(--tag-border-selected, 1.5px solid var(--mainGreen))'};
        ${({ $clickable }) =>
          $clickable &&
          css`
            :hover {
              background-color: var(--tag-chip-hover-bg-color, #0c5661);
            }
          `}
        svg {
          color: var(--tag-chip-color);
        }
      `) ||
    ($variant === TagVariants.MAIN &&
      css`
        background-color: var(--tag-main-bg-color);
        border: 1.5px solid transparent;
        ${({ $selected }) => $selected && 'border: var(--tag-border-selected, 1.5px solid var(--mainGreen))'};
        ${({ $clickable }) =>
          $clickable &&
          css`
            :hover {
              background: linear-gradient(0deg, var(--tag-main-hover-bg-color) 0%, var(--tag-main-hover-bg-color) 100%),
                var(--white);
            }
          `}

        svg {
          color: var(--tag-main-color);
        }
      `) ||
    ($variant === TagVariants.PRIMARY &&
      css`
        background-color: var(--tag-primary-bg-color, #2b4448);
        border: 1.5px solid transparent;
        ${({ $selected }) => $selected && 'border: var(--tag-border-selected, 1.5px solid var(--mainGreen, #79fbaf))'};
        ${({ $clickable }) =>
          $clickable &&
          css`
            :hover {
              background-color: var(--tag-primary-hover-bg-color, #475b5e);
            }
          `}
        svg {
          color: var(--tag-primary-color, #f5f9fa);
        }
      `)};

  ${({ $status, $solid }) =>
    $status &&
    ($solid
      ? css`
          background-color: ${STATUS_COLOR[$status]};
          border-color: transparent;
          svg {
            color: var(--tag-on-status-solid-color);
          }
        `
      : css`
          svg {
            color: ${STATUS_COLOR[$status]};
          }
        `)};

  ${({ $bgColor }) =>
    $bgColor &&
    css`
      background-color: ${$bgColor};
    `};
`;

export const TagContent = styled.div.attrs(() => ({
  className: 'tagContent'
}))`
  display: flex;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
  ${({ $variant }) =>
    ($variant === TagVariants.CHIP &&
      css`
        color: var(--tag-chip-color, #fff);
      `) ||
    ($variant === TagVariants.MAIN &&
      css`
        color: ${({ $clickable }) => ($clickable ? 'var(--tag-clickable-main-font-color)' : 'var(--tag-main-color)')};
      `) ||
    ($variant === TagVariants.PRIMARY &&
      css`
        color: var(--tag-primary-color, #f5f9fa);
      `)};

  ${({ $status, $solid }) =>
    $status &&
    ($solid
      ? css`
          color: var(--tag-on-status-solid-color);
        `
      : css`
          font-weight: 400;
        `)};
  cursor: ${({ $clickable }) => $clickable && 'pointer'};

  ${({ $ellipsis }) =>
    $ellipsis &&
    css`
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
      svg {
        color: ${$color};
      }
    `};
`;

export const CloseIcon = styled(Icons.Close).attrs(() => ({
  className: 'tagClose'
}))`
  margin-left: 10px;
  cursor: pointer;
  color: var(--tag-close-icon-color);
`;

export const TagsContainer = styled.div.attrs(() => ({
  className: 'tagsContainer'
}))`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  font-size: 12px;

  ${({ $tooltip }) =>
    $tooltip &&
    css`
      padding: 10px;
      max-height: 100%;
      overflow-y: auto;
    `}
`;

export const ColoredCircle = styled.div`
  width: 9px;
  height: 9px;
  background-color: ${({ $color }) => $color};
  border-radius: 10px;
`;
